import { Icon, type IconProps } from './Icon';

export function Box(props: IconProps) {
  return (
    <Icon strokeWidth={1.6} {...props}>
      <path d="M3 7l9-4 9 4v10l-9 4-9-4V7z" />
      <path d="M3 7l9 4 9-4M12 11v10" />
    </Icon>
  );
}
